// Import UI assets
import allChatsImage from "components/Icons/AllChats.jpg";
import defaultDisplayPic from "components/Icons/DefaultDP.jpeg";
import noRecordFound from "components/Icons/noRecordFound.jpg";
import whatsappBg from "components/Icons/ChinaUIIcons/whatsappbg.png";
import ICON_CONFIG from "./iconConfig";

const BRAND_CONFIG = {
 
  // Assets
  ASSETS: {
    IMAGES: {
      allChats: allChatsImage,
      defaultUser: defaultDisplayPic,
      noRecords: noRecordFound,
      whatsappBackground: whatsappBg,
    },
    
     ICONS: {
      ...ICON_CONFIG // Spread your existing icon config
    }
  },
  // Brand Identity
    IDENTITY: {
      NAME: "tispy.net",
      SUB_MAIN_CN: "cn.tispy.net",
      NAME_LOW_CAPS: "tispy",
      CONTACT_SUPPORT: "support@tispy.net"
    },


};

// Named exports (organized by category)
export const {
  ASSETS,
  IDENTITY
} = BRAND_CONFIG;

export default BRAND_CONFIG;
